export enum AnimationVariantEnum {
  FADE_UP = 'fade-up',
  FADE_LEFT = 'fade-left',
  FADE_RIGHT = 'fade-right',
  ZOOM = 'zoom'
}

export enum AnimationStateEnum {
  PENDING = 'pending',
  READY = 'ready'
}
